const favorite = {
  namespaced: true,
  state: {
    favorite: []
  },
  getters: {
    getFavorite: (state) => state.favorite
  },
  mutations: {
    setFavorite (state, favorite) {
      state.favorite = favorite
    }
  },
  actions: {
    setFavorite ({ commit }, favorite) {
      commit('setFavorite', favorite)
    }
  }
}

export default favorite



// WEBPACK FOOTER //
// ./src/vuex/favorite.js